var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More/Integration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 9V10.5H10.5C9.70435 10.5 8.94129 10.8161 8.37868 11.3787C7.81607 11.9413 7.5 12.7044 7.5 13.5V16.5C7.5 17.2956 7.81607 18.0587 8.37868 18.6213C8.94129 19.1839 9.70435 19.5 10.5 19.5H18C18.7956 19.5 19.5587 19.1839 20.1213 18.6213C20.6839 18.0587 21 17.2956 21 16.5V13.5C21 12.9734 20.8614 12.4561 20.5981 12C20.3348 11.544 19.956 11.1653 19.5 10.902V9.255C21.2475 9.873 22.5 11.5395 22.5 13.4985V16.4985C22.5 17.692 22.0259 18.8366 21.182 19.6805C20.3381 20.5244 19.1935 20.9985 18 20.9985H10.5C9.30653 20.9985 8.16193 20.5244 7.31802 19.6805C6.47411 18.8366 6 17.692 6 16.4985V13.5C6 12.3065 6.47411 11.1619 7.31802 10.318C8.16193 9.47411 9.30653 9 10.5 9H15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 15V13.5H13.5C14.2956 13.5 15.0587 13.1839 15.6213 12.6213C16.1839 12.0587 16.5 11.2956 16.5 10.5V7.5C16.5 6.70435 16.1839 5.94129 15.6213 5.37868C15.0587 4.81607 14.2956 4.5 13.5 4.5H6C5.20435 4.5 4.44129 4.81607 3.87868 5.37868C3.31607 5.94129 3 6.70435 3 7.5V10.5C3.00001 11.0266 3.13864 11.5439 3.40194 12C3.66525 12.456 4.04395 12.8347 4.5 13.098V14.745C3.62238 14.4345 2.86262 13.8595 2.32534 13.0993C1.78807 12.339 1.49972 11.4309 1.5 10.5V7.5C1.5 6.30653 1.97411 5.16193 2.81802 4.31802C3.66193 3.47411 4.80653 3 6 3H13.5C14.6935 3 15.8381 3.47411 16.682 4.31802C17.5259 5.16193 18 6.30653 18 7.5V10.5C18 11.6935 17.5259 12.8381 16.682 13.682C15.8381 14.5259 14.6935 15 13.5 15H9Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/Integration.6fa23d0bc9ba0784afff277327ad43ed.svg";
export { ForwardRef as ReactComponent };